import type { ReactNode } from 'react';
import { useI18n } from '../i18n';
import { Icon, SeverityIcon } from '../ui/Icon';

export function Banner({
  tone,
  children,
  action,
  onDismiss,
  testId,
}: {
  tone: 'info' | 'warning' | 'error';
  children: ReactNode;
  action?: ReactNode;
  onDismiss?: () => void;
  testId?: string;
}) {
  const { t } = useI18n();
  const toneCls = {
    info: 'bg-info/[0.08] border-info/25',
    warning: 'bg-warning/[0.10] border-warning/30',
    error: 'bg-error/[0.08] border-error/30',
  }[tone];
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      data-testid={testId}
      data-print-hide
      className={`flex items-center gap-2 border-b px-4 py-2 text-xs sm:px-6 ${toneCls}`}
    >
      <SeverityIcon severity={tone} size={13} />
      <div className="min-w-0 flex-1 text-fg">{children}</div>
      {action}
      {onDismiss && (
        <button type="button" onClick={onDismiss} className="rounded-pill p-1 text-muted hover:bg-fg/10 hover:text-fg" aria-label={t('banner.dismiss')}>
          <Icon name="x" size={12} />
        </button>
      )}
    </div>
  );
}
